import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { RequiredMark } from '../common';

export const FormTextInput = ({
	id,
	label = '',
	value,
	onChange,
	required,
	errorMessage,
	disabled,
	readOnly = false,
	placeholder
}) => {
	return (
		<Form.Group controlId={id}>
			<Form.Label>
				{label}
				{required && <RequiredMark />}
			</Form.Label>
			<Form.Control
				autoComplete="off"
				type="text"
				disabled={disabled}
				value={value}
				onChange={({ target }) => onChange(target.value)}
				readOnly={readOnly}
				placeholder={placeholder}
			/>
			{errorMessage && <div className="small text-danger">{errorMessage}</div>}
		</Form.Group>
	);
};

FormTextInput.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
	errorMessage: PropTypes.string
};
